import { BigNumber, BigNumberish } from '@ethersproject/bignumber'

export function getPathForPosition(synthId: string, positionId: BigNumberish): string {
  return `/vaults/${synthId.toLowerCase()}-${BigNumber.from(positionId)
    .toHexString()
    .replace('x0', 'x')}`
}
